import base from '../base/props'
import form from '../../../../../../props/form'

const localProps = {
  title: {
    type: String,
    default() {
      return this.$options.$$t('title', '')
    }
  },
  showTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showTitle', true)
    }
  },
  subTitle: {
    type: String,
    default() {
      return this.$options.$$t('subTitle', null)
    }
  },
  showSubTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showSubTitle', false)
    }
  },
  notice: {
    type: String,
    default() {
      return this.$options.$$t('notice', null)
    }
  },
  showNotice: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showNotice', false)
    }
  },
  classes: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('classes', null)
    }
  },
  error: {
    type: String,
  },
  modalClasses: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('modalClasses', null)
    }
  },
}
const packageProps = {
  definitions: {
    default() {
      return _.merge({}, this.$options.$$t('define', {}), this.$options.$$s('define', {}))
    }
  }
}
export const props = {
  ...base,
  ...form,
  ...localProps,
  ...packageProps
}
export default props
